<!--TEMPLATE-->
<template>
  <div class="orderline-summary">
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
          <span slot='title'>
            <span class='avenir-heavy'>Gegevens orderregel {{ title }}</span>
          </span>

          <dean-section-title-item
              :icon='phoneIcon'
              :content="true"
              @click.native="addPhoneNumberRange()"
              v-if="showAddPhoneNumberRangeButton()"
          >
            Telefoonnummerbereik toevoegen
          </dean-section-title-item>

          <dean-section-title-item
              :icon='phoneIcon'
              :content="true"
              @click.native="addPhoneNumber()"
              v-if="showAddPhoneNumberButton()"
          >
            Telefoonnummer toevoegen
          </dean-section-title-item>

          <dean-section-title-item
              :icon='phoneIcon'
              :content="true"
              @click.native="addPhoneNumberRange()"
              v-if="showUpdatePhoneNumberRangeButton()"
          >
            Telefoonnummerbereik toevoegen
          </dean-section-title-item>

          <dean-section-title-item
              :icon='phoneIcon'
              :content="true"
              @click.native="addPhoneNumber()"
              v-if="showUpdatePhoneNumberButton()"
          >
            Telefoonnummerbereik toevoegen
          </dean-section-title-item>

          <dean-section-title-item
              :icon='editIcon'
              :content="true"
              @click.native="editOdidoSimCardDetails()"
              v-if="showEditOdidoSimCardDetailsButton()"
          >
            Odido Simkaartgegevens bewerken
          </dean-section-title-item>

          <dean-section-title-item
              :icon='refreshIcon'
              :content="true"
              @click.native="refreshOdidoPortingDate()"
              v-if="showRefreshOdidoPortingDateButton()"
          >
            Vernieuw Odido - porteerdatum
          </dean-section-title-item>

          <dean-section-title-item
              :icon='repeatIcon'
              :content="true"
              @click.native="retryOdidoMobileProvisioning()"
              v-if="showRetryOdidoMobileProvisioningButton()"
          >
            Odido mobiele provisioning opnieuw proberen
          </dean-section-title-item>

          <dean-section-title-item
              :icon='cancelIcon'
              :content="true"
              @click.native="cancelKpnMobileProvisioning()"
              v-if="showCancelKpnMobileProvisioningButton()"
          >
            KPN mobiele nummerbehoud annuleren
          </dean-section-title-item>

          <dean-section-title-item
              :icon='editIcon'
              :content="true"
              @click.native="editKpnProvisioningDetails()"
              v-if="showEditKpnProvisioningDetailsButton()"
          >
            Bewerk KPN-provisioninggegevens
          </dean-section-title-item>

          <dean-section-title-item
              :icon='editIcon'
              :content="true"
              @click.native="changeMsisdn()"
              v-if="showChangeMsisdnButton()"
          >
            MSISDN wijzigen
          </dean-section-title-item>

          <dean-section-title-item
              v-if="canChangeOrderLineStatus()"
              :icon='statusIcon'
              :content="true"
              @click.native="changeStatus()"
          >
            Status wijzigen
          </dean-section-title-item>
          <dean-section-title-item
              v-if="canCancelOrderLine()"
              :icon='deleteIcon'
              :content="true"
              @click.native="cancelOrderline()"
          >
            Opzeggen
          </dean-section-title-item>
          <dean-section-title-item
              v-if="canAddComment()"
              :icon='messageIcon'
              :content="true"
              @click.native="addComment()"
          >
            Opmerking toevoegen
          </dean-section-title-item>
          <dean-section-title-item
              v-if="canViewStatusLog()"
              :icon='statusLogIcon'
              :content="true"
              @click.native="viewStatusLog()"
          >
            Status log
          </dean-section-title-item>
        </dean-section-title>

        <dean-notification>
        </dean-notification>

        <dean-section-divider v-if="shouldShowSimCardData()">SimCard data</dean-section-divider>
        <dean-table
            :data='simCardData'
            :columns='columns'
            v-if="shouldShowSimCardData()"
            @column-click='columnClick'
        >
        </dean-table>

        <dean-section-divider v-if="shouldShowOdidoMobileProvisioningData()">Odido mobile provisioning data</dean-section-divider>
        <dean-table
            :data='odidoMobileProvisioningData'
            :columns='columns'
            v-if="shouldShowOdidoMobileProvisioningData()"
            @column-click='columnClick'
        >
        </dean-table>

        <dean-section-divider v-if="shouldShowKpnMobileProvisioningData()">KPN mobile provisioning data</dean-section-divider>
        <dean-table
            :data='kpnMobileProvisioningData'
            :columns='columns'
            v-if="shouldShowKpnMobileProvisioningData()"
            @column-click='columnClick'
        >
        </dean-table>

        <dean-section-divider v-if="shouldShowAddonData()">Addon data</dean-section-divider>
        <dean-table
            :data='addonData'
            :columns='columns'
            v-if="shouldShowAddonData()"
            @column-click='columnClick'
        >
        </dean-table>

        <dean-section-divider v-if="shouldShowAdditionalData()">Overige data</dean-section-divider>
        <dean-table
            :data='additionalData'
            :columns='columns'
            v-if="shouldShowAdditionalData()"
            @column-click='columnClick'
        >
        </dean-table>

        <dean-section-divider v-if="shouldShowMainProductData()">Hoofdproduct data</dean-section-divider>
        <dean-table
            :data='mainProductData'
            :columns='columns'
            v-if="shouldShowMainProductData()"
            @column-click='columnClick'
        >
        </dean-table>

        <dean-section-divider v-if="shouldShowAddressData()">Adres</dean-section-divider>
        <dean-table
            :data='addressData'
            :columns='columns'
            v-if="shouldShowAddressData()"
            @column-click='columnClick'
        >
        </dean-table>

      </div>
    </div>
  </div>
</template>
<!--SCRIPT-->
<script lang="ts">
// VUE
import {Component} from 'vue-property-decorator';
import deanTableMixin from '@/mixins/deanTableMixin';
import {mixins} from 'vue-class-component';
import {deanDialogBus} from '@/main';
import axios from 'axios';
import {OrderStatusIdEnum} from '@/enums/OrderStatusEnum';

import {
  customerIcon,
  deanPagination,
  deanSectionDivider,
  deanSectionTitle,
  deanSectionTitleItem,
  deanTable,
  deleteIcon,
  featherIconPhoneForwarded,
  customIconProcessCancel,
  editIcon,
  globeIcon,
  invoicesIcon,
  messageIcon,
  partnerIcon,
  plusIcon,
  returnIcon,
  refreshIcon,
  warningIcon,
  saveIcon,
  featherIconRepeat,
  featherIconClock,
} from '@deanone/dean-components';
import deanNotification from '@/components/deanComponents/deanNotification.vue';
import statusIcon from '@/assets/svg/status.svg';
import {getDutchDateFormat, getDutchLongDateFormat} from '@/mixins/dateWrapper';
import {getPhoneNumberFromOrderLine} from '@/mixins/additionalDataPhoneNumber';
import {ServiceTypeEnum} from "@/enums/ServiceTypeEnum";
import {getErrorFromResponse} from "@/mixins/errorMessage";
import {authUserHasPrivilegeAndAction} from "@/mixins/privileges";
import {UserPrivilege} from "@/enums/UserPrivilege";
import {UserAction} from "@/enums/UserAction";
import {KpnPortingStatus} from "@/enums/KpnPortingStatus";
import {KpnProvisioningStatus} from "@/enums/KpnProvisioningStatus";

interface TableRow {
  label: string;
  value: any;
}

@Component({
  components: {
    deanSectionDivider,
    deanTable,
    deanPagination,
    deanSectionTitle,
    deanSectionTitleItem,
    deanNotification,
  },
})

export default class Details extends mixins(deanTableMixin) {
  // DATA
  public simCardData: Array<TableRow> = [];
  public addonData: Array<TableRow> = [];
  public additionalData: Array<TableRow> = [];
  public mainProductData: Array<TableRow> = [];
  public addressData: Array<TableRow> = [];
  public odidoMobileProvisioningData: Array<TableRow> = [];
  public kpnMobileProvisioningData: Array<TableRow> = [];
  public orderLineData: any = {};
  public title: string = '';
  public statusIcon: object = statusIcon;
  public deleteIcon: object = deleteIcon;
  public cancelIcon: object = customIconProcessCancel;
  public messageIcon: object = messageIcon;
  public refreshIcon: object = refreshIcon;
  public repeatIcon: object = featherIconRepeat;
  public plusIcon: object = plusIcon;
  public phoneIcon: object = featherIconPhoneForwarded;
  public editIcon: object = editIcon;
  public statusLogIcon: object = featherIconClock;

  public isPorting: boolean = false;
  public hasFailedOdidoMobileProvisioning: boolean = false;
  public hasFailedKpnMobileProvisioning: boolean = false;

  public terminationStatuses = [
    OrderStatusIdEnum.TERMINATION_REQUESTED,
    OrderStatusIdEnum.TERMINATED,
    OrderStatusIdEnum.DECLINED,
  ];

  public phoneNumberAddableStatuses: Array<string> = [
    OrderStatusIdEnum.IN_PROGRESS,
    OrderStatusIdEnum.ACCEPTED,
    OrderStatusIdEnum.PLANNED,
    OrderStatusIdEnum.ON_HOLD,
    OrderStatusIdEnum.INVOICED,
    OrderStatusIdEnum.TERMINATION_REQUESTED
  ];

  public simCardDataKeysToAddMapping: Array<string> = [
    'Odido referentie',
    'userName',
    'tmlOldNumber',
    'tmlCopyNumber',
    'tmlCopyNumber2',
    'simNumber',
    'simNumber2',
    'numberToPort',
    'isPorting',
    'portingCompanyName',
    'portingCurrentProvider',
    'portingCustomerNr',
    'portingCurrentContract',
    'subscriberId',
    'chain_id',
    'simType',
    'simProvider',
    'isESim',
    'isPhysicalSim',
    'email',
    'activationCode',
  ];

  public dateLabels: Array<string> = [
    'wishDate',
    'portingDate',
    'portingWishDate',
    'portingApprovedDate',
    'portingFirstPossibleDate',
  ];

  public sideMenuData: {
    label?: any,
    customer?: any,
    partition?: any,
    partner?: any,
    changeStatus?: any,
    comment?: any,
    info?: any,
    mainProduct?: any,
  } = {};
  public columns: { [p: string]: object } = {
    label: {
      content: 'Gegeven',
      align: 'left',
      sort: false,
      dql: 'label',
    },
    value: {
      content: 'Waarde',
      align: 'left',
      sort: false,
      dql: 'value',
    },
  };

  // COMPUTED
  get orderlineMetaData() {
    return this.pageMeta;
  }

  public canChangeOrderLineStatus(): boolean {
    if (
      this.orderLineData.status?.id !== OrderStatusIdEnum.TERMINATED
      && this.orderLineData.status?.id !== OrderStatusIdEnum.DECLINED
      && authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.CHANGE_STATUS)
    ) {
      return true;
    }

    return false;
  }

  public canCancelOrderLine(): boolean {
    if (!this.orderLineData.status?.id) {
      return false;
    }

    if (this.terminationStatuses.includes(this.orderLineData.status.id)) {
      return false;
    }

    if (!authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.CANCEL)) {
      return false;
    }

    if (this.orderLineData.serviceType === ServiceTypeEnum.MOBILE_KPN) {
      return this.orderLineData.status.id === OrderStatusIdEnum.INVOICED;
    }

    return true;
  }

  public canAddComment(): boolean {
    if (
      this.orderLineData.status?.id
      && authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.CHANGE_STATUS)
    ) {
      return true;
    }

    return false;
  }

  public canViewStatusLog(): boolean {
    return this.$store.getters.getUser.privileges.includes('view-status-log-orderline');
  }

  public tableName(): string {
    return 'order-orderline-details';
  }

  // METHODS
  public cancelOrderline() {
    deanDialogBus.$emit('open', 'OrderCancelOrderlineDialog', {
      data: this.$route.params.cpId,
      mode: 'single',
    });
  }

  public addPhoneNumber() {
    deanDialogBus.$emit('open', 'AddPhoneNumberDialog', {
      orderLineId: this.$route.params.cpId,
      phoneNumber: this.orderLineData.additionalData?.phoneNumber,
    });
  }

  public retryOdidoMobileProvisioning(): void
  {
    this.$store.dispatch('setLoadOverlay', true);

    axios.post('/-/trade/api/mobile.order.line.provisioning.retry', {
      orderLineId: this.$route.params.cpId,
    })
    .then(
      (response: any) => {
        this.$store.dispatch('setLoadOverlay', false);

        this.$toast({
          icon: saveIcon,
          text: String(this.$t('messages.retryMobileProvisioning')),
          theme: 'success',
        });

        this.loadInfo(this.pageMeta);
      },
      (error: any) => {
        this.$store.dispatch('setLoadOverlay', false);

        const errorMessage: string|null = getErrorFromResponse(
            error.response.data,
            'Request failed.'
        );

        this.$toast({
          icon: warningIcon,
          text: errorMessage ?? '',
          theme: 'danger',
        });
      },
    );
  }

  public cancelKpnMobileProvisioning(): void
  {
    deanDialogBus.$emit('open', 'CancelProvisioningConfirmationDialog', {
      orderLineId: this.$route.params.cpId,
    });
  }

  private showAddPhoneNumberButton(): boolean {
    if (! this.orderLineData.productRequiresPhoneNumber) {
      return false;
    }

    if (this.orderLineData.additionalData?.isProvisioned) {
      return false;
    }

    if (this.orderLineData.additionalData?.phoneNumber) {
      return false;
    }

    if (! this.$store.getters.getUser.privileges.includes('change-phone-number-orderline')) {
      return false;
    }

    if (! this.orderLineData.status) {
      return false;
    }

    if (! this.phoneNumberAddableStatuses.includes(this.orderLineData.status.id)) {
      return false;
    }

    return true;
  }

  private showUpdatePhoneNumberButton(): boolean {
    if (! this.orderLineData.productRequiresPhoneNumber) {
      return false;
    }

    if (this.orderLineData.additionalData?.isProvisioned) {
      return false;
    }

    if (! this.orderLineData.additionalData?.phoneNumber) {
      return false;
    }

    if (! this.$store.getters.getUser.privileges.includes('change-phone-number-orderline')) {
      return false;
    }

    if (! this.orderLineData.status) {
      return false;
    }

    // for new order lines created after provisioning feature
    if (!this.phoneNumberAddableStatuses.includes(this.orderLineData.status.id)) {
      return false;
    }

    return true;
  }

  public addPhoneNumberRange() {
    deanDialogBus.$emit('open', 'AddPhoneNumberRangeDialog', {
      orderLineId: this.$route.params.cpId,
      phoneNumberRangeFrom: this.orderLineData.additionalData?.phoneNumberRangeFrom,
      phoneNumberRangeTo: this.orderLineData.additionalData?.phoneNumberRangeTo,
      phoneNumberBlockSize: this.orderLineData.productPhoneNumberBlockSize,
    });
  }

  public editOdidoSimCardDetails() {
    deanDialogBus.$emit('open', 'EditSimCardDetailsDialog', {
      orderLineId: this.$route.params.cpId,
      partnerCode: this.orderLineData.partner.code,
      customerId: this.orderLineData.customer.id,
      searchType: this.orderLineData.productSimType,
      searchProvider: this.orderLineData.productSimProvider,
      simNumber: this.orderLineData.simCardData.number,
      msisdn: this.orderLineData.simCardData.msisdn,
      customerNumber: this.orderLineData.simCardData.customerNumber,
      msisdnToPort: this.orderLineData.simCardData.msisdnToPort,
      portingWishDate: this.orderLineData.simCardData.portingWishDate,
      portingContractHandling: this.orderLineData.simCardData.portingContractHandling,
      odidoMobileProvisioningErrorCode: this.orderLineData.odidoMobileProvisioning?.provisioningErrorCode,
    });
  }

  public editKpnProvisioningDetails() {
    deanDialogBus.$emit('open', 'EditKpnProvisioningDetailsDialog', {
      orderLineId: this.$route.params.cpId,
      canChangeDonorCustomerNumber: this.canChangeDonorCustomerNumberOnKpnProvisioning(),
      canChangePortingWishDate: this.canChangePortingWishDateOnKpnProvisioning(),
      donorCustomerNumber: this.orderLineData.additionalData.portingCustomerNr,
      portingWishDate: this.orderLineData.statusDates.wishDate,
      firstPossiblePortingDate: this.orderLineData.stnMobileProvisioning?.portingFirstPossibleDate,
    });
  }

  public changeMsisdn() {
    deanDialogBus.$emit('open', 'ChangeMsisdnDialog', {
      orderLineId: this.$route.params.cpId,
      simNumber: this.orderLineData.simCardData?.number,
      msisdn: this.orderLineData.simCardData?.msisdn,
      msisdnToPort: this.orderLineData.simCardData?.msisdnToPort,
      isPorting: this.isPorting,
    });
  }

  public refreshOdidoPortingDate() {
    this.$emit('setLoad', true);

    const requestPayload = {
      orderLineId: this.$route.params.cpId,
    };

    axios.post('/-/trade/api/mobile.order.line.refresh.provisioningPortingDate', requestPayload).then(
      (response: any) => {

        this.$store.dispatch('setLoadOverlay', true);

        this.loadInfo(this.pageMeta);

        this.$toast(this.$store.state.main.notification.messages.refreshedPortingDate);
      },
      (error: any) => {
        this.$store.dispatch('setLoadOverlay', true);

        // TODO handle errors
        this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
      },
    ).finally(() => {
      this.$store.dispatch('setLoadOverlay', false);
    });
  }

  private showAddPhoneNumberRangeButton(): boolean {
    if (! this.orderLineData.productRequiresPhoneNumberBlock) {
      return false;
    }

    if (this.orderLineData.additionalData?.isProvisioned) {
      return false;
    }

    if (this.orderLineData.additionalData?.phoneNumberRangeFrom && this.orderLineData.additionalData?.phoneNumberRangeTo) {
      return false;
    }

    if (! this.$store.getters.getUser.privileges.includes('change-phone-number-range-orderline')) {
      return false;
    }

    if (! this.orderLineData.status) {
      return false;
    }

    if (! this.phoneNumberAddableStatuses.includes(this.orderLineData.status.id)) {
      return false;
    }

    return true;
  }

  public showEditOdidoSimCardDetailsButton(): boolean {
    if (this.orderLineData.serviceType !== ServiceTypeEnum.MOBILE_ODIDO) {
      return false;
    }

    if (
        this.orderLineData.status?.id === OrderStatusIdEnum.TERMINATED
        || this.orderLineData.status?.id === OrderStatusIdEnum.DECLINED
        || this.orderLineData.status?.id === OrderStatusIdEnum.INVOICED
    ) {
      return false;
    }

    if (
      this.orderLineData.odidoMobileProvisioning?.provisioningErrorCode !== 'ERR_SIM_CARD_ACTIVATION_FAILED'
      && this.orderLineData.odidoMobileProvisioning?.provisioningErrorCode !== 'ERR_INVALID_PORTING_REQUEST'
      && this.orderLineData.odidoMobileProvisioning?.provisioningErrorCode !== 'ERR_PORTING_REQUEST_FAILED'
    ) {
      return false;
    }

    return this.$store.getters.getUser.privileges.includes('edit-mobile-provisioning-details-orderline');
  }

  public showRefreshOdidoPortingDateButton(): boolean {
    if (this.orderLineData.serviceType !== ServiceTypeEnum.MOBILE_ODIDO) {
      return false;
    }

    if (this.orderLineData.odidoMobileProvisioning?.provisioningCompleted) {
      return false;
    }

    if (this.orderLineData.odidoMobileProvisioning?.provisioningFailed) {
      return false;
    }

    if (this.orderLineData.odidoMobileProvisioning?.provisioningStep !== 'porting_requested') {
      return false;
    }

    if (! this.orderLineData.odidoMobileProvisioning?.portingDate) {
      return false;
    }

    return this.$store.getters.getUser.privileges.includes('refresh-provisioning-porting-date-orderline');
  }

  private showUpdatePhoneNumberRangeButton(): boolean {
    if (! this.orderLineData.productRequiresPhoneNumberBlock) {
      return false;
    }

    if (this.orderLineData.additionalData?.isProvisioned) {
      return false;
    }

    if (
        !this.orderLineData.additionalData?.phoneNumberRangeFrom
        && !this.orderLineData.additionalData?.phoneNumberRangeTo
    ) {
      return false;
    }

    if (! this.$store.getters.getUser.privileges.includes('change-phone-number-orderline')) {
      return false;
    }

    if (! this.orderLineData.status) {
      return false;
    }

    if (! this.phoneNumberAddableStatuses.includes(this.orderLineData.status.id)) {
      return false;
    }

    return true;
  }

  public showRetryOdidoMobileProvisioningButton(): boolean {
    if (this.orderLineData.serviceType !== ServiceTypeEnum.MOBILE_ODIDO) {
      return false;
    }

    if (
        this.hasFailedOdidoMobileProvisioning
        && this.orderLineData.status?.id !== OrderStatusIdEnum.TERMINATED
        && this.orderLineData.status?.id !== OrderStatusIdEnum.DECLINED
        && this.orderLineData.status?.id !== OrderStatusIdEnum.INVOICED
        && authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.RETRY_MOBILE_ORDER_PROVISIONING)
    ) {
      return true;
    }

    return false;
  }

  public showCancelKpnMobileProvisioningButton(): boolean {
    if (!this.isPorting) {
      return false;
    }

    if (this.orderLineData.serviceType !== ServiceTypeEnum.MOBILE_KPN) {
      return false;
    }

    if (!authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.CANCEL_MOBILE_ORDER_PROVISIONING)) {
      return false;
    }

    if (
      this.hasFailedKpnMobileProvisioning
      && this.orderLineData.status?.id !== OrderStatusIdEnum.TERMINATED
      && this.orderLineData.status?.id !== OrderStatusIdEnum.DECLINED
      && this.orderLineData.status?.id !== OrderStatusIdEnum.INVOICED
    ) {
      return true;
    }

    return false;
  }

  public showEditKpnProvisioningDetailsButton(): boolean {
    if (!this.isPorting) {
      return false;
    }

    if (this.orderLineData.serviceType !== ServiceTypeEnum.MOBILE_KPN) {
      return false;
    }

    if (!authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.EDIT_MOBILE_PROVISIONING_DETAILS)) {
      return false;
    }

    return this.canChangeDonorCustomerNumberOnKpnProvisioning() || this.canChangePortingWishDateOnKpnProvisioning();
  }

  public showChangeMsisdnButton(): boolean {
    if (this.orderLineData.serviceType !== ServiceTypeEnum.MOBILE_ODIDO) {
      return false;
    }

    if (!authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.CHANGE_MSISDN)) {
      return false;
    }

    return true;
  }

  public canChangeDonorCustomerNumberOnKpnProvisioning(): boolean {
    if (
      this.hasFailedKpnMobileProvisioning
      && this.orderLineData.status?.id !== OrderStatusIdEnum.TERMINATED
      && this.orderLineData.status?.id !== OrderStatusIdEnum.DECLINED
      && this.orderLineData.status?.id !== OrderStatusIdEnum.INVOICED
    ) {
      return true;
    }

    return false;
  }

  public canChangePortingWishDateOnKpnProvisioning(): boolean {
    if (
      this.hasFailedKpnMobileProvisioning
      && this.orderLineData.status?.id !== OrderStatusIdEnum.TERMINATED
      && this.orderLineData.status?.id !== OrderStatusIdEnum.DECLINED
      && this.orderLineData.status?.id !== OrderStatusIdEnum.INVOICED
    ) {
      return true;
    }

    if (
      !this.hasFailedKpnMobileProvisioning
      && [OrderStatusIdEnum.ON_HOLD, OrderStatusIdEnum.PLANNED].includes(this.orderLineData.status?.id)
      && this.orderLineData.stnMobileProvisioning.provisioningStatus === KpnProvisioningStatus.BUSY
      && this.orderLineData.stnMobileProvisioning.portingStatus === KpnPortingStatus.APPROVED
    ) {
      return true;
    }

    return false;
  }

  public changeStatus(): void {
    deanDialogBus.$emit('open', 'OrderChangeStatus', {
      title: 'status orderregel wijzigen',
      isChangeSingle: true,
      id: this.$route.params.cpId,
      invoiceDate: this.orderLineData.statusDates.invoiceDate,
      serviceType: this.orderLineData.serviceType,
    });
  }

  public addComment(): void {
    deanDialogBus.$emit('open', 'AddCommentDialog', {
      title: 'opmerking toevoegen',
      id: this.$route.params.cpId,
    });
  }

  public viewStatusLog(): void {
    deanDialogBus.$emit('open', 'ViewStatusLogDialog', {
      orderLineId: this.$route.params.cpId,
    });
  }

  public sideMenu(): object {
    const id = this.$route.params.transactionId;
    return {
      content: {
        title: {
          text: this.sideMenuData.label,
          mobile: {
            close: {
              text: 'Close',
              icon: invoicesIcon,
            },
          },
        },
        type: 'themed',
        sections: {
          main: {
            items: {
              back: {
                title: 'Terug naar order',
                icon: returnIcon,
                name: 'orders.orderlines',
                params: {transactionId: id},
              },
            },
          },
          actions: {
            title: 'acties',
            items: this.sideMenuActions(),
          },
          data: {
            title: 'informatie orderregel',
            items: this.sideMenuData.info,
          },
        },
      },
    };
  }

  public loadInfo(data: any): void {
    this.$store.dispatch('setLoadOverlay', true);
    axios.post('/-/trade/api/order.line.info', {
      cpId: this.$route.params.cpId,
      pageMeta: data,
    }).then(
      (response) => {
        const orderLineData = response.data;

        this.orderLineData = orderLineData;
        this.isPorting = orderLineData?.additionalData?.isPorting;
        this.hasFailedOdidoMobileProvisioning = orderLineData?.odidoMobileProvisioning?.provisioningFailed;
        this.hasFailedKpnMobileProvisioning = orderLineData?.stnMobileProvisioning?.provisioningFailed;

        this.simCardData = [];
        this.addonData = [];
        this.additionalData = [];
        this.mainProductData = [];
        this.addressData = [];
        this.odidoMobileProvisioningData = [];
        this.kpnMobileProvisioningData = [];

        // show sim card data
        if (orderLineData.serviceType === ServiceTypeEnum.MOBILE_ODIDO) {
          if (orderLineData.customer.tMobileReference) {
            if (orderLineData.isMainProduct) {
              this.pushToSimCardData('Odido referentie', orderLineData.customer.tMobileReference, true);
            } else {
              this.pushToMainProductData('Odido referentie', orderLineData.customer.tMobileReference);
            }
          }
        }

        // show additional data from service, prepend "service" to the field name
        for (const key in orderLineData.serviceAdditionalData) {
          if (orderLineData.serviceAdditionalData.hasOwnProperty(key)) {
            this.pushToAdditionalData('service' + this.capitalizeFirstLetter(key), orderLineData.serviceAdditionalData[key]);
          }
        }

        // show additional data from main product, for addons
        if (
            false === orderLineData.isMainProduct
            && orderLineData.mainProduct?.additionalData
        ) {
          for (const key in orderLineData.mainProduct.additionalData) {
            if (orderLineData.mainProduct.additionalData.hasOwnProperty(key)) {
              this.pushToMainProductData(key, orderLineData.mainProduct.additionalData[key]);
            }
          }
        }

        // show sim card data from current product
        for (const key in orderLineData.simCardData) {
          if (orderLineData.simCardData.hasOwnProperty(key)) {
            if (orderLineData.isMainProduct) {
              this.pushToSimCardData(key, orderLineData.simCardData[key], true);
            } else {
              this.pushToAddonData(key, orderLineData.simCardData[key], true);
            }
          }
        }

        // show additional data from current product
        for (const key in orderLineData.additionalData) {
          if (orderLineData.additionalData.hasOwnProperty(key)) {
            this.pushToAdditionalData(key, orderLineData.additionalData[key]);

            if (orderLineData.isMainProduct) {
              this.pushToSimCardData(key, orderLineData.additionalData[key]);
            } else {
              this.pushToAddonData(key, orderLineData.additionalData[key]);
            }
          }
        }

        // show address data
        if (orderLineData.address) {
          for (const key in orderLineData.address) {
            if (orderLineData.address.hasOwnProperty(key)) {
              this.pushToAddressData(key, orderLineData.address[key]);
            }
          }
          this.reorderAddressData();
        }

        // show odido provisioning data
        if (orderLineData.odidoMobileProvisioning) {
          for (const key in orderLineData.odidoMobileProvisioning) {
            if (orderLineData.odidoMobileProvisioning.hasOwnProperty(key)) {
              this.pushToOdidoMobileProvisioningData(key, orderLineData.odidoMobileProvisioning[key]);
            }
          }
        }

        // show kpn provisioning data
        if (orderLineData.stnMobileProvisioning) {
          for (const key in orderLineData.stnMobileProvisioning) {
            if (orderLineData.stnMobileProvisioning.hasOwnProperty(key)) {
              this.pushToKpnMobileProvisioningData(key, orderLineData.stnMobileProvisioning[key]);
            }
          }
        }

        this.title = orderLineData.productName;

        if (orderLineData.productClass) {
          this.title = orderLineData.productClass + ' - ' + orderLineData.productName;
        }

        // const responseSideMenu = orderLineData.sidemenu;
        this.sideMenuData = {
          label: 'Order ' + orderLineData.orderNumber,
          customer: {
            id: orderLineData.customer.id,
            label: 'Klant (' + orderLineData.customer.name + ')',
          },
          partition: {
            customerId: orderLineData.customer.id,
            label: 'Cloud PBX (' + orderLineData.customer.name + ')',
          },
          partner: {
            id: orderLineData.partner.id,
            label: 'Partner (' + orderLineData.partner.name + ')',
          },
          changeStatus: {
            label: 'Status wijzigen (' + orderLineData.status.name + ')',
          },
          comment: null,
          info: [],
        };

        if (orderLineData.mainProduct) {
          this.sideMenuData.mainProduct = orderLineData.mainProduct;
        }

        this.sideMenuData.info = {
          currentStatus: {
            title: 'Huidige status: ' + orderLineData.status.name,
            icon: statusIcon,
            readonly: true,
          },
          lastStatusChange: {
            title: 'Laatste wijziging: ' + getDutchLongDateFormat(orderLineData.statusDates.lastStatusChange),
            icon: statusIcon,
            readonly: true,
          },
          wishDate: {
            title: 'Wensdatum: ' + getDutchDateFormat(orderLineData.statusDates.wishDate),
            icon: statusIcon,
            readonly: true,
          },
          acceptedDate: {
            title: 'Acceptatiedatum: ' + getDutchDateFormat(orderLineData.statusDates.acceptedDate),
            icon: statusIcon,
            readonly: true,
          },
          deliveryDate: {
            title: 'Plandatum: ' + getDutchDateFormat(orderLineData.statusDates.deliveryDate),
            icon: statusIcon,
            readonly: true,
          },
          invoiceDate: {
            title: 'Facturatiedatum: ' + getDutchDateFormat(orderLineData.statusDates.invoiceDate),
            icon: statusIcon,
            readonly: true,
          },
          declinedDate: {
            title: 'Afgewezen op: ' + getDutchDateFormat(orderLineData.statusDates.declinedDate),
            icon: statusIcon,
            readonly: true,
          },
          terminationRequestDate: {
            title: 'Opgezegd wensdatum op: ' + getDutchDateFormat(orderLineData.statusDates.terminationRequestDate),
            icon: statusIcon,
            readonly: true,
          },
          terminationDate: {
            title: 'Opzegging verwerkt op: ' + getDutchDateFormat(orderLineData.statusDates.terminationDate),
            icon: statusIcon,
            readonly: true,
          },
          cancellationDate: {
            title: 'Annuleringsdatum: ' + getDutchDateFormat(orderLineData.statusDates.cancellationDate),
            icon: statusIcon,
            readonly: true,
          },
        };

        if (
            orderLineData.mainProduct
            && orderLineData.mainProduct.serviceType === ServiceTypeEnum.MOBILE_ODIDO
        ) {
          const phoneNumber = getPhoneNumberFromOrderLine(orderLineData.mainProduct);

          this.sideMenuData.info.mainProduct = {
            title: `Gekoppeld aan: ${phoneNumber}`,
            icon: globeIcon,
            readonly: true,
          };
        }

        for (const key in this.sideMenuData.info) {
          if (Object.keys(orderLineData.statusDates).includes(key)) {
            if (orderLineData.statusDates[key] === null) {
              delete this.sideMenuData.info[key];
            }
          }
        }
        this.$store.dispatch('updateSideMenu', this.sideMenu());
      },
      (error) => {
        this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
      },
    ).finally(() => {
      this.$store.dispatch('setLoadOverlay', false);
    });
  }

  public created() {
    this.loadInfo(this.pageMeta);
  }

  public mounted() {
    deanDialogBus.$on('saved', () => {
      this.loadInfo(this.pageMeta);
    });
  }

  public destroyed() {
    deanDialogBus.$off('saved');
  }

  private pushToAdditionalData(label: string, value: any): void {
    value = this.formatValue(label, value);
    label = this.formatLabel(label);

    if (this.containsData(this.additionalData, label, value)) {
      return;
    }

    this.additionalData.push({
      label,
      value,
    });
  }

  private pushToAddressData(label: string, value: any): void {
    value = this.formatValue(label, value);
    label = this.formatLabel(label);

    if (value && !this.containsData(this.addressData, label, value)) {
      this.addressData.push({
        label,
        value,
      });
    }

    this.removeFromAdditionalData(label, value);
  }

  private pushToSimCardData(label: string, value: any, forcePush: boolean = false): void {
    if (
      this.orderLineData.serviceType !== ServiceTypeEnum.MOBILE_ODIDO
      && this.orderLineData.serviceType !== ServiceTypeEnum.MOBILE_KPN
    ) {
      return;
    }

    if (
      !forcePush
      && !this.simCardDataKeysToAddMapping.includes(label)
    ) {
      return;
    }

    value = this.formatValue(label, value);
    label = this.formatLabel(label);

    if (!this.containsLabel(this.simCardData, label)) {
      this.simCardData.push({
        label,
        value,
      });
    }

    this.removeFromAdditionalData(label, value);
  }

  private pushToAddonData(label: string, value: any, forcePush: boolean = false): void {
    if (
      this.orderLineData.serviceType !== ServiceTypeEnum.MOBILE_ODIDO
      && this.orderLineData.serviceType !== ServiceTypeEnum.MOBILE_KPN
    ) {
      return;
    }

    if (
      !forcePush
      && !this.simCardDataKeysToAddMapping.includes(label)
    ) {
      return;
    }

    value = this.formatValue(label, value);
    label = this.formatLabel(label);

    if (
      !this.containsData(this.mainProductData, label, value)
      && !this.containsLabel(this.addonData, label)
    ) {
      this.addonData.push({
        label,
        value,
      });
    }

    this.removeFromAdditionalData(label, value);
  }

  private pushToMainProductData(label: string, value: any): void {
    if (
      true === this.orderLineData.isMainProduct
      || !this.orderLineData.mainProduct?.additionalData
    ) {
      return;
    }

    value = this.formatValue(label, value);
    label = this.formatLabel(label);

    if (
      !this.containsData(this.mainProductData, label, value)
      && !this.containsData(this.addonData, label, value)
    ) {
      this.mainProductData.push({
        label,
        value,
      });
    }

    this.removeFromAdditionalData(label, value);
  }

  private pushToOdidoMobileProvisioningData(label: string, value: any): void {
    value = this.formatValue(label, value);
    label = this.formatLabel(label);

    if (value && !this.containsData(this.odidoMobileProvisioningData, label, value)) {
      this.odidoMobileProvisioningData.push({
        label,
        value,
      });
    }
  }

  private pushToKpnMobileProvisioningData(label: string, value: any): void {
    value = this.formatValue(label, value);
    label = this.formatLabel(label);

    if (value && !this.containsData(this.kpnMobileProvisioningData, label, value)) {
      this.kpnMobileProvisioningData.push({
        label,
        value,
      });
    }
  }

  private removeFromAdditionalData(label: string, value: any): void {
    const index = this.additionalData.findIndex(
        (data) => data.label === label && data.value === value
    );

    if (index !== -1) {
      this.additionalData.splice(index, 1);
    }
  }

  private containsData(dataArray: Array<TableRow>, label: string, value: any): boolean {
    return dataArray.some((data) => data.label === label && data.value === value);
  }

  private containsLabel(dataArray: Array<TableRow>, label: string): boolean {
    return dataArray.some((data) => data.label === label);
  }

  private reorderAddressData(): void {
    const labelOrder: Array<string> = [
      'Postcode',
      'Huisnummer',
      'Huisnummer toevoeging',
      'Straat',
      'Plaats',
    ];

    this.addressData.sort((a, b) => {
      const indexA = labelOrder.indexOf(a.label);
      const indexB = labelOrder.indexOf(b.label);

      // If a label is not in the list, it will stay in its current position (no reordering)
      return (indexA === -1 ? this.addressData.length : indexA) - (indexB === -1 ? this.addressData.length : indexB);
    });
  }

  private shouldShowAdditionalData(): boolean
  {
    if (this.additionalData.length > 0) {
      return true;
    }

    return false;
  }

  private shouldShowAddressData(): boolean
  {
    if (this.addressData.length > 0) {
      return true;
    }

    return false;
  }

  private shouldShowSimCardData(): boolean
  {
    if (
      (
        this.orderLineData.serviceType === ServiceTypeEnum.MOBILE_ODIDO
        || this.orderLineData.serviceType === ServiceTypeEnum.MOBILE_KPN
      ) && this.simCardData.length > 0
    ) {
      return true;
    }

    return false;
  }

  private shouldShowOdidoMobileProvisioningData(): boolean
  {
    if (
      this.orderLineData.serviceType === ServiceTypeEnum.MOBILE_ODIDO
      && this.odidoMobileProvisioningData.length > 0
    ) {
      return true;
    }

    return false;
  }

  private shouldShowKpnMobileProvisioningData(): boolean
  {
    if (
      this.orderLineData.serviceType === ServiceTypeEnum.MOBILE_KPN
      && this.kpnMobileProvisioningData.length > 0
    ) {
      return true;
    }

    return false;
  }

  private shouldShowAddonData(): boolean
  {
    if (
      (
        this.orderLineData.serviceType === ServiceTypeEnum.MOBILE_ODIDO
        || this.orderLineData.serviceType === ServiceTypeEnum.MOBILE_KPN
      ) && this.addonData.length > 0
    ) {
      return true;
    }

    return false;
  }

  private shouldShowMainProductData(): boolean
  {
    if (this.mainProductData.length > 0) {
      return true;
    }

    return false;
  }

  private formatValue(label: string, value: string|number|null): string {
    if (value === null) {
      return '';
    }

    if (typeof value === 'number') {
      value = value.toString();
    }

    const translationKey = 'values.' + value;

    if (this.$te(translationKey)) {
      return this.$t(translationKey).toString();
    }

    if (this.dateLabels.includes(label)) {
      return getDutchDateFormat(value);
    }

    return value;
  }

  private formatLabel(label: string): string {
    const translationKey = 'labels.' + label;

    if (this.$te(translationKey)) {
      return this.$t(translationKey).toString();
    }

    return label;
  }

  private capitalizeFirstLetter(str: string): string {
    if (!str) {
      return '';
    }

    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  private sideMenuActions() {
    const items: any = {
      customer: {
        title: this.sideMenuData.customer.label,
        icon: customerIcon,
        name: 'customers.edit',
        params: {
          id: this.sideMenuData.customer.id,
        },
      },
      partition: {
        title: this.sideMenuData.partition.label,
        icon: globeIcon,
        name: 'provisioning.partition.info',
        params: {
          customerId: this.sideMenuData.customer.id,
        },
      },
    };

    if (this.$store.getters.getUser.privileges.includes('view-partner')) {
      items.partner = {
        title: this.sideMenuData.partner.label,
        icon: partnerIcon,
        name: 'partners.edit',
        params: {
          pid: this.sideMenuData.partner.id,
        },
      };
    }

    if (this.canChangeOrderLineStatus()) {
      items.changeStatus = {
        title: this.sideMenuData.changeStatus.label,
        icon: statusIcon,
        name: 'OrderChangeStatus',
        params: {
          modal: true,
          title: 'status orderregel wijzigen',
          isChangeSingle: true,
          id: this.$route.params.cpId,
          serviceType: this.orderLineData.serviceType,
        },
      };
    }

    items.comment = {
      title: 'Opmerkingen',
      icon: messageIcon,
      name: 'OrderViewLastMessageDialog',
      params: {
        modal: true,
        cpId: this.$route.params.cpId,
      },
    };

    if (this.sideMenuData.mainProduct) {
      items.mainProduct = {
        title: `Naar ${this.sideMenuData.mainProduct.serviceName} dienst`,
        icon: globeIcon,
        name: 'customers.service.edit',
        params: {
          pid: this.sideMenuData.customer.id,
          serviceId: this.sideMenuData.mainProduct.serviceId,
        },
      };
    }

    return items;
  }

}
</script>
<!--STYLE-->
<style lang="scss" scoped>

</style>
